export const useStyles = (theme) => ({
  root: {
    padding: 10,
  },
  title: {
    display: "flex",
    alignItems: "center",
  },
  tooltip: {
    "&:hover": {
      cursor: "pointer",
    },
  },
  listitemContent: {
    display: "flex",
    [theme.breakpoints.down(760)]: {
      flexDirection: "column",
    },
  },
  listitemDetails: {
    paddingTop: 15,
    paddingBottom: 15,
    marginRight: 5,
  },
  paper: {
    padding: 20,
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
  },
});
